const state = {
  games: [
    {
      nameTag: 'sniperhonor',
      nameShow: '千纹时空',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/sniperhonor/sniperhonor_icon.jpg',
      bgImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/sniperhonor/sniperhonor_bg.png',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/sniperhonor/sniperhonor_play_landscape.png',
      intro: '《荣耀狙击》是一款非常真实的狙击游戏。',
      plat: 'Android',
      category: '体育射击',
      video:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/sniperhonor/sniperhonor.mp4',
      appleStore: '',
      googlePlay: '',
      yunbuGame: 'https://l.taptap.cn/t4TVmtbk?channel=rep-rep_7lctheztzbz',
      // yunbuGame:
      //   'https://cdn.yunbugame.com/yunbu/yunbu/apps/com.yunbu.sniperhonor.iapppay/apks/d8c4812a62ce44fea0fe6495b5f67d3e.apk',
      date: '2019年8月8日',
      desc: '置身于黑帮势力统治的都市中，隐藏在暗处狙击目标。透过瞄准镜，悄无声息的将目标送入永恒的长眠！在这里，你可以体验到精美的3D画面。在这里，你可以了解到真实的狙击手故事。数十种不同类型的任务，海量的狙击装备，多种多样的场景地形。在罪恶的都市中，维护正义，伸张和平。为了荣耀而战！',
      detail:
        '-真实3D画面，场景精美震撼<br><br>-上百种狙击装备任意挑选<br><br>-海量关卡和任务，等你来挑战<br><br>-多种道具，为你的战斗提供便利<br><br>-生化感染：未知病菌肆虐，马上消灭四处横行的丧尸！<br><br>云步互娱致力于为全世界玩家提供精品游戏，为他们打造一个纯净、美好、平等且充满趣味的世界。<br><br>化身正义的狙击手制裁黑恶势力<br><br>立刻开始狙击行动！完成致命狙击任务'
    },
    {
      nameTag: 'puppyblast',
      nameShow: '甜点消消',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/puppyblast/puppyblast_icon.png',
      bgImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/puppyblast/puppyblast_bg.png',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/puppyblast/puppyblast_play_landscape.png',
      intro: '全民都爱玩的合成家装改造大作战！',
      plat: 'Android',
      category: '合成消除',
      video: '',
      appleStore: '',
      googlePlay: '',
      // yunbuGame: '',
      yunbuGame: 'https://l.taptap.cn/z0iwKiC6?channel=rep-rep_1lrs1ws8i4r',
      date: '2023年8月9日',
      desc: '甜点消消是一款玩法简单画风清新容易上手的家装消除游戏，在游戏里你将扮演设计师凯洛琳，帮助好友对房子进行装修。动动手指对材料进行合成，解决难关开启星星宝箱和宝藏袋，收集宝贵的钱币和道具，交付任务获取资源，通过装修推动主线剧情，简单上手，轻松休闲。',
      detail:
        '1.容易上手：游戏玩法简单易懂，没有复杂的内容，拖拽合并收集物件，进行家居设计，帮助你爱上家装<br><br>2.轻松游玩：在读书或工作间隙放松玩5分钟；如果您有一个空闲的下午，可以享受几个小时的游戏<br><br>3.自由装饰：根据喜好随心选择设计方案，无规则，一切的设计都可随心所欲，你的装修你做主<br><br>4.第二棋盘：随着游戏进度触发惊喜棋盘，挑战不同玩法，获得放松、满足以及减压的游玩体验<br><br>5.剧情丰富：完成订单、开拓客户获取资源进行剧情推动，涌现设计灵感，经营自己的工作室<br><br>6.获取奖杯：锦标赛模式下可以与其他地区的大师竞争，看谁更厉害'
    },
    {
      nameTag: 'monster',
      nameShow: '怪可爱的店',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/monster/monster_icon.png',
      bgImg: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/monster/monster_bg.jpg',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/monster/monster_play_landscape.jpg',
      intro:
        '宇宙之大，去不了的都是远方，但在怪店，凡有愿望，必定满足！即刻启程，来一场不同寻常的经营之旅吧！',
      plat: 'Android',
      category: '经营养成',
      video: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/monster/monster.mp4',
      appleStore: '',
      googlePlay: '',
      yunbuGame: '',
      // yunbuGame: 'https://l.tapdb.net/JEBXrvph?channel=rep-rep_udv5bid8l2t_id229874',
      date: '2023年7月14日',
      desc: '《怪可爱的店》是一款画风独特的模拟放置经营游戏，你将成为店铺的老板，打造一个小怪物们的休憩之所！招待千奇百怪的客人，让他们沉醉在饭桌上！聆听它们的故事！这里有很多种商店，你可以自由地解锁不同的商店来获得金币，通过招待怪物客人，体验有趣的经营旅程！',
      detail:
        '【可爱画风，图鉴收集】<br>无比可爱的手绘风格，憨态可掬的二次元的怪物形象，诡异又可爱，收集怪物图鉴、解锁怪物事件，发现小怪物们的奇遇故事！<br><br>【经营系统，放置玩法】<br>操作简单，烹饪、装修、种地、搜集食材、烧烤…只需要点击屏幕上的各种按钮就可以完成各种经营操作，解锁装饰、升级设备、雇佣员工、组织培训，做好经营管理，轻松成为店长！<br><br>【耕作经营，遍寻食材】<br>丰富的菜谱内容，上天入地搜集各种食材，种菜、钓鱼、上山下海探索，为小怪物们提供来自大自然的无公害美食！升级食材、研发菜品一切只为更好地服务小怪物们！<br><br>【特色模块，暖心之旅】<br>经营许愿屋，挖掘小怪物们背后动人心弦的神秘故事，并实现它们的心愿！培育可爱小精灵，疗愈心灵 ！'
    },
    {
      nameTag: 'alicemergeland',
      nameShow: '糖果精灵传奇',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/alicemergeland/alicemergeland_icon.png',
      bgImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/alicemergeland/alicemergeland_bg.jpg',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/alicemergeland/alicemergeland_play_landscape.jpg',
      intro: '使用合并魔法，唤醒沉睡仙境！',
      plat: 'Android',
      category: '合成消除',
      video: '',
      appleStore: '',
      googlePlay: '',
      // yunbuGame: '',
      yunbuGame: 'https://l.taptap.cn/QQxQU0Va?channel=rep-rep_edi38eei6js',
      date: '2023年6月14日',
      desc: '使用合并魔法，唤醒沉睡仙境！茫茫的迷雾之中隐藏着一个神秘的世界，曾经繁荣的糖果仙境在黑魔法的影响下陷入沉睡……拯救这片土地的唯一希望就是使用你的合并魔法，驱散迷雾并解除诅咒，唤醒你的伙伴，一起让仙境重新焕发生机。',
      detail:
        '茫茫的迷雾之中隐藏着一个神秘的世界，曾经繁荣的糖果仙境在黑魔法的影响下陷入沉睡……<br><br>拯救这片土地的唯一希望就是使用你的合并魔法，驱散迷雾并解除诅咒，唤醒你的伙伴，一起让仙境重新焕发生机。<br><br>游戏特色<br>– 解锁经典角色，和你的伙伴一同探索仙境<br>– 丰富的梦幻岛屿主题，茶话会，槌球场，荒岛求生……各色主题应有尽有<br>– '
    },
    {
      nameTag: 'badmintonleague',
      nameShow: '羽毛球高高手',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/badmintonleague/badmintonleague_icon.png',
      bgImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/badmintonleague/badmintonleague_bg.jpg',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/badmintonleague/badmintonleague_play_landscape.jpg',
      intro: '史上最具竞技趣味的羽毛球游戏',
      plat: 'Android',
      category: '体育竞速',
      video:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/badmintonleague/badmintonleague.mp4',
      appleStore: '',
      googlePlay: '',
      yunbuGame: 'https://l.taptap.cn/rpVzQV8G?channel=rep-rep_ag8trlqybhz',
      date: '2018年8月8日',
      desc: '史上最具竞技趣味的羽毛球游戏！绝对大开你的眼界。作为体育运动的羽毛球游戏中加入了操作的元素，玩起来更具挑战和趣味。真实的模拟羽毛球运动，在腾空扣杀对手和措手不及的网前球中，体验不一样的精彩！',
      detail:
        '史上最具竞技趣味的羽毛球游戏！绝对大开你的眼界。作为体育运动的羽毛球游戏中加入了操作的元素，玩起来更具挑战和趣味。<br><br>真实的模拟羽毛球运动，在腾空扣杀对手和措手不及的网前球中，体验不一样的精彩！简洁大方的UI设计，清新自然的美术风格，仿佛置身于羽毛球球场中！不同难度的游戏模式，菜鸟到大师进阶之路由你来开辟！<br><br>就是现在，拿起你的球拍，对准羽毛球来一记漂亮的扣杀，疯狂碾压你的对手！<br><br>游戏特色<br>– 五种游戏模式，全新【世界超级联赛】等你来战<br>– 逼真的击球体验，近吊远攻加扣杀，胜负只在一球之间<br>– 独创天赋系统，随心所欲打造明星球员<br>– 精心设计的羽毛球配件及运动套装，引领球场时尚潮流<br>– 酷炫的技能，酷炫的扣杀，一起燃爆全场<br>– 在天梯模式中与大师们一决高低吧，你就是最强王者<br>– 好友对战，离线模式，随时随地畅玩到底<br><br>赶紧抢先下载体验吧！口袋里的羽毛球，快玩转于指尖吧，秒杀世界各地的高手！<br><br>展现你的球技，让观众们为你疯狂！为你打call！'
    },
    {
      nameTag: 'lionandmouse',
      nameShow: '狮子和老鼠',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/lionandmouse/lionandmouse_icon.png',
      bgImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/lionandmouse/lionandmouse_bg.jpg',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/lionandmouse/lionandmouse_play_landscape.jpg',
      intro: '和小动物一起组建交响乐团',
      plat: 'Android,iOS',
      category: '休闲益智',
      video:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/lionandmouse/lionandmouse.mp4',
      appleStore: 'https://itunes.apple.com/cn/app/lion-mouse-orchestra/id1356046617',
      googlePlay: 'https://play.google.com/store/apps/details?id=com.yunbu.LionAndMouse',
      yunbuGame: '',
      date: '2018年8月8日',
      desc: '欢迎来到 狮子和老鼠 – 儿童音乐创意游戏！我们认为自然世界对于孩子来说精彩异常。除了为孩子们提供了无限玩乐的机会，孩子们还可以通过探索、发现、创造来深入建立真实世界的认知。',
      detail:
        '欢迎来到 狮子和老鼠 – 儿童音乐创意游戏！<br>我们认为自然世界对于孩子来说精彩异常。除了为孩子们提供了无限玩乐的机会，孩子们还可以通过探索、发现、创造来深入建立真实世界的认知。<br><br>家长提示：<br>-应用内没有任何广告，请放心使用<br>-乐队功能通过首页右上角按钮进入，乐队模块包含大量的沙盒探索内容，建议和孩子一同体验<br>围绕着自然的主题，深入浅出的伊索寓言故事,您的孩子可以:<br>-通过富有亲和力的动画，音效和反馈，同游戏中的21个小动物互动<br>-通过探索和发现，收集11种经典的乐器，并演奏动听的乐曲<br>-穿插其中的经典的益智游戏，培养孩子数字，几何学，力学的基础概念<br>-体会友爱，互助的价值导向<br><br>特色<br>– 在9个精心设计的章节中，体会伊索语言完整的故事，相遇，相识，相助，相爱<br>– 和21个可爱的小动物音乐师亲切的互动<br>– 体验iOS 11带来的游戏AR场景，以全新的方式，身临其境般在小动物身边进行探索<br>– 培养孩童的细节发现能力，在所有场景中寻找组建乐队所需的乐器<br>– 成为小小指挥家，在整个乐队中指挥所有的乐队成员演奏动人的乐曲<br>– 严格遵守COPPA儿童隐私保护法案<br>– 无内付费和第三方广告<br><br>关于我们：<br>我们致力于激发儿童的好奇心，让所有儿童有保持惊奇，保持探索的天性，让孩子们能够善于发现，并且创造他们所热爱的世界。'
    },
    {
      nameTag: 'bubbleelfsaga',
      nameShow: '泡泡精灵传奇',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/bubbleelfsaga/bubbleelfsaga_icon.png',
      bgImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/bubbleelfsaga/bubbleelfsaga_bg.jpg',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/bubbleelfsaga/bubbleelfsaga_play_landscape.jpg',
      intro: '正版丨超人气的经典萌版泡泡龙',
      plat: 'Android',
      category: '休闲益智',
      video: '',
      appleStore: '',
      googlePlay: '',
      yunbuGame: '',
      date: '2018年8月8日',
      desc: '泡泡精灵传奇——2.0全新版本，更惊艳的人物与特效、更具挑战的关卡、更丰富好玩的道具、更多福利道具助你过关~ 泡泡精灵传奇是一款休闲的泡泡龙游戏，精心策划的关卡，好好利用每一个泡泡击碎它们完成关卡，解救精灵宝宝！',
      detail:
        '泡泡精灵传奇——2.0全新版本，更惊艳的人物与特效、更具挑战的关卡、更丰富好玩的道具、更多福利道具助你过关~<br><br>泡泡精灵传奇是一款休闲的泡泡龙游戏，精心策划的关卡，好好利用每一个泡泡击碎它们完成关卡，解救精灵宝宝！在游戏中和精灵公主一起踏上魔幻冒险之旅，去探索神秘未知的魔法世界吧！<br><br>一路披荆斩棘通过越来越难的关卡，并利用精灵之力完成任务。泡泡爆破魔法道具能帮助你解救精灵宝宝…组合使用威力强大哦~！<br><br>游戏特色：<br>-775多个丰富的冒险关卡，均设有独特的障碍，每周都会添加新关卡哦！<br>-全新的魔法泡泡，全新的积分，全新的闯关模式<br>-神奇的魔法技能，奇妙的组合技能，祝您勇夺高分<br>-细腻的游戏体验，令人惊艳的图像效果，真实的物理模拟技术<br>-让人欲罢不能的游戏节奏与奖励进程<br>-40M小包体，光速下载<br>-不用流量，畅玩到底'
    },
    {
      nameTag: 'arcadepool',
      nameShow: '街机台球大师',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/arcadepool/arcadepool_icon.png',
      bgImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/arcadepool/arcadepool_bg.jpg',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/arcadepool/arcadepool_play_landscape.png',
      intro: '全球首款真人实时对战桌球手游',
      plat: 'Android',
      category: '体育竞速',
      video: '',
      appleStore: '',
      googlePlay: '',
      yunbuGame: 'https://l.taptap.cn/blvvHxy0?channel=rep-rep_hdn5rz9w5ez',
      // yunbuGame:
      //   'https://yuncdn.yunbu.me/yunbu/apps/arcadepool/apks/04d208c7bb8f4214baa257fd97f32343.apk',
      date: '2018年8月8日',
      desc: '全球首款真人实时对战桌球手游，完美还原现实8球玩法，简单流行的操作方式，绚丽的动画特效，配以真实的物理参数，精准的进球，激动人心的赛事，究竟谁才是冠军？让我们拭目以待。',
      detail:
        '《街机台球大师》全球首款真人实时对战桌球手游，完美还原现实8球玩法，简单流行的操作方式，绚丽的动画特效，配以真实的物理参数，精准的进球，激动人心的赛事，究竟谁才是冠军？让我们拭目以待。<br><br>【游戏特色】<br>*演绎经典*<br>还原现实桌球玩法，配以真实物理参数，让广大桌球爱好者玩的得心应手，杆净利落。<br><br>*全球竞技*<br>挑战网络上来自全世界的朋友在3D台球世界对战，从草根轻松成长为台球明星。<br><br>*竞技对战*<br>游戏中设有各种公开赛事，玩家可以自由选择参与，并用自己精湛的技巧赢得巨额的比赛筹码，挑战最 高的成就，成为业界传奇！<br><br>*酷炫球杆*<br>游戏中配置超过40根球杆，还在不断增加，挑选你满意的伴随你的职业生涯！彰显至尊身份！<br><br>*单机练习*<br>不用流量也能玩，努力提高你的技艺，进阶更高等的赛事，向冠军发起冲击！<br><br>*WIFI对战*<br>让您与亲朋好友、室友在等餐、候车、就寝前随时随地的畅快对战。<br><br>*真实3D模型*<br>逼真的3D游戏效果，让人眼前一亮如亲临实战，更细腻的光影设计，更流畅的滚动效果等待你来体验。'
    },
    {
      nameTag: 'restauranttycoon',
      nameShow: '美食城大亨',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/restauranttycoon/restauranttycoon_icon.png',
      bgImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/restauranttycoon/restauranttycoon_bg.jpg',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/restauranttycoon/restauranttycoon_play_landscape.jpg',
      intro: '一款全新好玩的餐厅经营游戏!',
      plat: 'Android',
      category: '经营养成',
      video: '',
      appleStore: '',
      googlePlay: '',
      yunbuGame: '',
      date: '2018年8月8日',
      desc: '成为顶级大厨， 快手烹饪和上菜！一款全新好玩的时间管理美食游戏！ 作为一个优秀的精英大厨，你现在可以建设属于你自己的顶级餐厅，选择食材，装饰店铺。经营制作各种美食，有汉堡，披萨，热狗，牛排，让顾客慕名而来，满意而归。',
      detail:
        '成为顶级大厨， 快手烹饪和上菜！一款全新好玩的时间管理美食游戏！<br><br>作为一个优秀的精英大厨，你现在可以建设属于你自己的顶级餐厅，选择食材，装饰店铺。经营制作各种美食，有汉堡，披萨，热狗，牛排，让顾客慕名而来，满意而归。<br><br>品尝世界各国经典美食，畅游各国风情餐厅，你准备给顾客做最好的食物了吗？快来展示你的厨艺，开启餐厅，制作美食，让你的厨艺更加精湛，让客人们开启精彩的环球美食之旅！<br><br>游戏特点：<br>1、通过经营餐厅获取利润，开启更多不同国家、不同特色的美食店铺；<br>2、体验亚洲独特的美食风俗，美式狂野的烹饪盛宴，欧洲精致的西餐文化，以及少数国家那富有独特魅力的饮食情怀，这一切都等着你的加入！<br>3、地图、店铺持续更新中……敬请期待！'
    },
    {
      nameTag: 'coloringcreative',
      nameShow: '宝宝爱画画',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/coloringcreative/coloringcreative_icon.png',
      bgImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/coloringcreative/coloringcreative_bg.jpg',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/coloringcreative/coloringcreative_play_landscape.jpg',
      intro: '邂逅色彩，填出美丽画作!',
      plat: 'Android',
      category: '休闲益智',
      video:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/coloringcreative/coloringcreative.mp4',
      appleStore: '',
      googlePlay: '',
      yunbuGame: '',
      date: '2018年8月8日',
      desc: '一款益智填色应用，绘画从未如此简单！用数字填色释放压力！ 特色： – 精选数量众多的填色页，满足各个年龄段儿童、大人任何喜好！ – 大量绝美的图片，探索每日更新的新图片集，来进行数字填色！ – 自己DIY，拍自拍照或任何照片，为自己的像素图片填色！ – 各种填色工具，使用魔术棒为相同数字的多个相邻格子填色，轻松完成作品！',
      detail:
        '一款益智填色应用，绘画从未如此简单！用数字填色释放压力！<br><br>特色：<br>– 精选数量众多的填色页，满足各个年龄段儿童、大人任何喜好！<br>– 大量绝美的图片，探索每日更新的新图片集，来进行数字填色！<br>– 自己DIY，拍自拍照或任何照片，为自己的像素图片填色！<br>– 各种填色工具，使用魔术棒为相同数字的多个相邻格子填色，轻松完成作品！<br>– 提高你和孩子的专注力、稳定性<br>– 释放压力，打发无聊的时间<br><br>不用费心挑选颜色，快来填色吧！和孩子、朋友一起完成许多很酷或充满艺术质感的像素作品。享受轻松惬意的美好时光！<br><br>让我们发挥自己的想象力与灵感，创作起来吧！'
    },
    {
      nameTag: 'candyprincess',
      nameShow: '彩虹糖果公主',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/candyprincess/candyprincess_icon.png',
      bgImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/candyprincess/candyprincess_bg.jpg',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/candyprincess/candyprincess_play_landscape.jpg',
      intro: '成为最甜美的糖果公主',
      plat: 'Android',
      category: '经营养成',
      video:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/candyprincess/candyprincess.mp4',
      appleStore: '',
      googlePlay: '',
      yunbuGame: '',
      date: '2018年8月8日',
      desc: '成为最甜美的糖果公主，做出最美味的甜品。 快来为你的糖果公主穿上缀满宝石的闪亮长裙，化上如糖果般的甜美妆容。你一定想不到还能制作缀满糖果的漂亮指甲和蓬松柔软的小蛋糕。然而最令人兴奋的是你还能通过糖果爆破游戏获得精美的礼物！',
      detail:
        '成为最甜美的糖果公主，做出最美味的甜品。<br>快来为你的糖果公主穿上缀满宝石的闪亮长裙，化上如糖果般的甜美妆容。你一定想不到还能制作缀满糖果的漂亮指甲和蓬松柔软的小蛋糕。然而最令人兴奋的是你还能通过糖果爆破游戏获得精美的礼物！如果你也喜欢甜美的糖果和蛋糕，就快来糖果公主的绚丽世界实现自己的甜蜜梦想吧！<br><br>游戏特点：<br>*实现每个女孩心中糖果世界的公主梦！<br>*各种各样的美妆工具和糖果色的裙子等你来搭配！<br>*创造精致的糖果美甲！<br>*玩糖果消除游戏获得精美的礼品！<br>*不同的糖果公主让你眼前一亮！<br>*拍照留下自己心中的完美时刻！'
    },
    {
      nameTag: 'magicgarden',
      nameShow: '花花姑娘之魔法花园',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/magicgarden/magicgarden_icon.png',
      bgImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/magicgarden/magicgarden_bg.jpg',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/magicgarden/magicgarden_play_landscape.jpg',
      intro: '悉心培育花朵，召唤花花姑娘',
      plat: 'Android',
      category: '经营养成',
      video: '',
      appleStore: '',
      googlePlay: '',
      yunbuGame: '',
      date: '2018年8月8日',
      desc: '你是否曾经想过，拥有一块魔法花园，各式各样的花朵都会在你的精心照料下盛开，每一朵花都拥有魔力，它们会陪伴你，让你开心快乐，并且越来越美。',
      detail:
        '你是否曾经想过，拥有一块魔法花园，各式各样的花朵都会在你的精心照料下盛开，每一朵花都拥有魔力，它们会陪伴你，让你开心快乐，并且越来越美。<br><br>清早起床，你发现自家的花园真的不太一样了。花朵变换成了美丽的花花姑娘，她和你成为了朋友，并赠送给你用花朵制作的各式各样美丽的服装。<br><br>快去商店购买各式各样的花朵种子来播种吧，你会得到各种各样美丽的花朵，并且和不同的花花姑娘成为朋友。她们会为你制作美丽的衣服，装扮你的生活。你的生活也会变得五彩缤纷。看似普通的花园最终会变成你的梦幻城堡！<br><br>游戏特色：<br>-独特的美术风格，颜色清丽，笔触细腻，表情唯美生动传神。<br>-超多种类的花朵可以种植，培育出稀有品种的花朵。<br>-积累种植经验，进阶高级花匠。<br>-使用召唤术，召唤出美丽服装。<br>-换装小屋有上百件美丽衣服可供搭配。<br>-60余款精美套装，等你来搜集。<br>-图鉴里面有各种花朵、套装、花花姑娘的详细介绍。<br>-多个场景，等待你解锁新的篇章。'
    },
    {
      nameTag: 'decormerge',
      nameShow: '环游点点消',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/decormerge/decormerge_icon.png',
      bgImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/decormerge/decormerge_bg.jpg',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/decormerge/decormerge_play_landscape.jpg',
      intro: '轻松上手，自由装饰，丰富剧情',
      plat: 'Android',
      category: '合成消除',
      video: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/decormerge/decormerge.mp4',
      appleStore: '',
      googlePlay: '',
      yunbuGame: 'https://l.taptap.cn/gHqAw1mj?channel=rep-rep_d7z9uqinymu',
      date: '2024年6月3日',
      desc: '艾琳娜和她的妹妹阿丽娅搬家到了一个简陋的尘土飞扬的房子里。现在有一个机会，你可以帮助他们设计，装饰和装修他们的家，把他们改造成你梦寐以求的空间！这是一个合成家装游戏，结合了合成玩法和室内家居设计，里面设置了许多未布置的房间，供你创造，装饰，翻新和布置！',
      detail:
        '游戏特色：<br>1、轻松上手：将拼图游戏板上的两个相同元素合并，创造新的物品和工具，以翻新客厅、卧室、厨房、花园和温室等各种房间；<br>2、自由装饰：合并两个相同的对象后，您将获得用于解锁和升级每件家具和房间角落的工具，翻新和粉刷房屋或豪宅。<br>3、风格多样：通过完成改造或重新设计空间的过程，享受放松的时间，展示你梦想中的房子。<br>4、获取奖杯：锦标赛模式下可以与其他地区的大师竞争，看谁更厉害。<br>5、丰富剧情：艾琳娜和阿丽娅将会遇到很多新朋友——英俊外向的菲尼克斯，神秘的索恩将会开始讲述他们的故事。索恩和天科怎么了？另外，艾琳娜和阿丽娅的故事也很神秘，为什么他们的父母突然离开了？等着你去解决和发现！<br><br>享受装饰和合并的同时，通过合并收集奖励来翻新家具和墙壁，装饰各种房间风格和类型的客栈和豪宅，探索人物的故事和解锁隐藏的区域，相信你一定会喜欢这款游戏！'
    },
    {
      nameTag: 'defendcliff',
      nameShow: '守卫悬崖',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/defendcliff/defendcliff_icon.png',
      bgImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/defendcliff/defendcliff_bg.jpg',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/defendcliff/defendcliff_play_landscape.jpg',
      intro: '风靡全球的时尚玩法：随机生成、随机合成！',
      plat: 'Android',
      category: '合成消除',
      video:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/defendcliff/defendcliff.mp4',
      appleStore: '',
      googlePlay: '',
      yunbuGame: 'https://l.taptap.cn/MKoJXFvj?channel=rep-rep_tvzr5l5kz5g',
      date: '2023年8月8日',
      desc: '在无尽的征战旅程之中，不断召唤与合成，使用你的泰坦英雄和英灵搭建阵营，制定战略，开启比赛，剩下的就全交给运气吧！ ！ ！',
      detail:
        '风靡全球的时尚玩法：随机生成、随机合成！<br>--选择五张卡牌组成你的战队，不断召唤新的英灵为你防御敌方<br>--3*5的特色棋盘，英灵将在指定的位置随机出现！<br>--随机合成的打造策略，更加强大的升级威力，为战场带来巨大的挑战性与未知性<br>豪华海量的泰坦英雄及特色阵营兵种<br>--强大的攻击类兵种快速消灭敌人进而为你的胜利积累优势<br>--精妙的辅助类兵种和狡猾的刺客类为你的队伍增强实力，消灭敌人的战士<br>--还有强力的无属性炸弹兵种炸翻全场！<br>--更有颠覆战场的泰坦英雄，大范围攻击技能、虚弱敌人、召唤城墙等，瞬间扭转战局，反败为胜！<br><br>与世界玩家即时在线匹配的PVP对战<br>--「1V1对战」打造专属阵营，利用英雄及合成战略攻克对手，获取奖杯与成就！<br>--「2V2合作竞技」与战友协同压制敌方，共同获取胜利的荣耀与奖励！<br><br>丰富的休闲玩法及海量的活动模式持续不断！<br>--体验不同阵容且探索冒险的「远古迷宫」<br>--每周将与强劲的对手一决雌雄「荣誉竞技场」<br>--在异界中挑战征服远古的怪物「异界狩猎」<br>--迈上更高的天梯与新颖的BOSS机制「冒险之路」<br>--更有大量主题活动、奖杯旅程、赛季PASS卡、豪华宝箱等带你萌新起航！'
    },
    {
      nameTag: 'motorider',
      nameShow: '真实摩托锦标赛',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/motorider/motorider_icon.png',
      bgImg: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/motorider/motorider_bg.jpg',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/motorider/motorider_play_landscape.jpg',
      intro: '职业模式中，成为奖励任务的收猎者',
      plat: 'Android',
      category: '体育竞技',
      video: '',
      appleStore: '',
      googlePlay: '',
      yunbuGame: 'https://l.taptap.cn/tDtRGQ9r?channel=rep-rep_qlcojwk9rgb',
      date: '2023年8月8日',
      desc: '玩法多样的三种游戏模式！继承传统摩托车赛车游戏简单暴力玩法的同时，我们加入了职业模式、无尽模式和限时模式。',
      detail:
        '在职业模式中，成为奖励任务的收猎者。在限时模式中，体验全力加速突破极限。在无尽模式中，超越那些不合格的菜鸟们！但是无论哪种模式，要做的事情都很简单--从车库中选择喜欢赛车，然后跨上摩托车，加速！超车！搞事！超越对手，超越疾风，成为这场赛道冒险的王者！<br>成为优秀的摩托车手除了必要的冒险精神外，炫酷的摩托车也是不可或缺的！我们车库中拥有大量炫酷的摩托车，来自世界各地的车型。升级，改造的玩法也让这场在手掌中的荣耀之战变得奇妙无比。<br>在一场场刺激的竞赛中成为称霸赛场的王者吧！<br><br>特征：<br>● 拥有简单暴力的第一人称视角<br>● 逼真的3D场景和车辆音效<br>● 3种游戏模式：职业模式，限时模式，无尽模式<br>● 丰富的曲目和百变的场景<br>● 来自世界各地的车型任你选择，不断更新！<br><br>提示：<br>● 更多的金币，就在限时模式和无尽模式中。<br>● 不断升级你的爱车，让你变得更强。<br>● 速度越快，得到的分数越多。<br>● 两种视角切换，驾驶更加得心应手。'
    },
    {
      nameTag: 'nonogram',
      nameShow: '数独趣味闯关',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/nonogram/nonogram_icon.png',
      bgImg: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/nonogram/nonogram_bg.jpg',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/nonogram/nonogram_play_landscape.jpg',
      intro: '解决数字逻辑谜题，揭示隐藏的像素图片！',
      plat: 'Android',
      category: '休闲益智',
      video: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/nonogram/nonogram.mp4',
      appleStore: '',
      googlePlay: '',
      yunbuGame: 'https://l.taptap.cn/eaJCiT00?channel=rep-rep_nxwlnrxkh4l',
      date: '2023年8月8日',
      desc: '解决数字逻辑谜题，揭示隐藏的像素图片！每通过一道数图谜题，你能获得一块拼图碎片，数织与拼图玩法结合的游戏！',
      detail:
        '解决数字逻辑谜题，揭示隐藏的像素图片！<br>每通过一道数图谜题，你能获得一块拼图碎片，数织与拼图玩法结合的游戏！<br>在这里你可以探索超多主题畅游超过2000多幅的美丽图片世界。<br><br>通过基本的规则和逻辑背后的图片交叉难题训练你的大脑<br>●超多不同主题的谜题<br>●在特别的拼图游戏中放松<br>●一旦你开始游戏便会沉浸其中<br>●从“非常容易”到“专家”的难度级别<br>●游戏中有很多辅助功能，如返回上一步、获取提示、重置游戏等<br>●自动保存每个拼图，如果你卡住了，你可以尝试另一个拼图，稍后再回来<br>●每周挑战不同的全新任务，并获得丰厚的游戏物品奖励<br>接受挑战，享受无尽的解谜乐趣！'
    },
    {
      nameTag: 'pool3',
      nameShow: '台球风云',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/pool3/pool3_icon.png',
      bgImg: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/pool3/pool3_bg.jpg',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/pool3/pool3_play_landscape.jpg',
      intro: '身临其境的感受台球运动的独特魅力和体育精神',
      plat: 'Android',
      category: '体育竞技',
      video: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/pool3/pool3.mp4',
      appleStore: '',
      googlePlay: '',
      yunbuGame: 'https://l.taptap.cn/GwfZATJp?channel=rep-rep_spnkwndxhre',
      date: '2023年8月8日',
      desc: '超真实的还原了现实台球的各种摩擦碰撞的运动表现，让人身临其境的感受台球运动的独特魅力和体育精神',
      detail:
        '【游戏简介】<br>台球风云是一款线上3D台球游戏，视觉效果绝佳！具备一流手感的免费桌球手游，通过自研的物理引擎，超真实的还原了现实台球的各种摩擦碰撞的运动表现，让人身临其境的感受台球运动的独特魅力和体育精神。只要不放弃，你就是最强王者。<br><br>【游戏玩法】<br>模式多样：游戏内含8球，9球，斯诺克三大玩法，总有一款适合你<br>单机练习：球场小白变身大神只有一步之遥<br>真实对战：模拟真实对战场景，身临其境的游戏体验<br>好友功能：以球会友，切磋台球技艺；多人在线聊天系统让你和朋友零距离沟通，还能邀请您的好友来场别开生面的友谊赛<br>台球俱乐部：通过创建or加入俱乐部大显身手，在众多高手中脱颖而出，创建属于自己的团队，每周更有丰富的专属俱乐部奖励等你来拿<br><br>【游戏特色】<br>1.享受不同的背景和配乐<br>2.参加培养逻辑思维和准确性的活动<br>3.直观物理操控<br>4.一杆清台'
    },
    {
      nameTag: 'arkcraft2',
      nameShow: '帝国史诗',
      icon: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/arkcraft2/arkcraft2_icon.png',
      bgImg: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/arkcraft2/arkcraft2_bg.jpg',
      playImg:
        'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/arkcraft2/arkcraft2_play_landscape.jpg',
      intro: '战场上驰骋，利用走位和战术击败敌人并挑战最终BOSS',
      plat: 'Android',
      category: '体育竞技',
      video: 'http://yuncdn.yunbu.me/yunbu/officialsite/static/cn/games/arkcraft2/arkcraft2.mp4',
      appleStore: '',
      googlePlay: '',
      yunbuGame: 'https://l.taptap.cn/xtld90ef?channel=rep-rep_tptfzayer6l',
      date: '2023年8月8日',
      desc: '《帝国史诗》是一款竖屏射击类手游，单手操作，简单易上手，在战场上驰骋，利用走位和战术击败敌人并挑战最终BOSS。游戏还拥有大量炫酷的可升级枪支，精良的装备，以及令人上瘾的游戏玩法，会让你的手指发痒，让你的战略头脑刮起风暴！',
      detail:
        '【游戏特色】<br>- 单手操作，自动射击<br>走位、躲避、奔跑和掩护，然后干掉多个目标，完成无尽的惊险动作并获得超棒的奖励。<br><br>- 丰富的武器类型<br>几十种不同的枪械可供收集、珍藏和升级，包括手枪、霰弹枪、狙击枪甚至手榴弹等等。 <br>在关卡中赚取金币并完成通关任务，建立你的武器库并找到适合你射击风格的枪支，然后对其进行升级以制造出真正令人敬畏的武器，让你的敌人心生恐惧！<br><br>- 在线合作闯关模式<br>有困难？在线摇人！与同伴携手战斗，相互照应，挑战高难度关卡。<br><br>- 独一无二的英雄技能<br>7大英雄，能力各异，收集英雄碎片，解锁各大英雄，用炫酷的技能征服战场上的敌人。<br><br>- 不同的游戏模式<br>城市保卫战、首领之战、远征等各种模式任你选择，多种玩法带给你酣畅淋漓地战斗射击体验！'
    }
  ]
}

const getters = {
  getGameByName: (state) => (names) => {
    return state.games.filter((game) => names.indexOf(game.nameTag) > -1)
  },
  getGame: (state) => (name) => {
    return state.games.find((game) => game.nameTag === name)
  }
}

export default {
  state,
  getters
}
